import {css} from "styled-components"

export const LatoLight = css`font-family: LatoLight, sans-serif;`
export const Lato = css`font-family: Lato, sans-serif;`
export const LatoSemibold = css`font-family: LatoSemibold, sans-serif;`
export const LatoBold = css`font-family: LatoBold, sans-serif;`
export const Rubik = css`font-family: Rubik, sans-serif;`
export const RubikBold = css`font-family: RubikBold, sans-serif;`

export const WorkSansLight = css`font-family: WorkSansLight, sans-serif;`
export const WorkSans = css`font-family: WorkSans, sans-serif;`
export const WorkSansMedium = css`font-family: WorkSansMedium, sans-serif;`
export const WorkSansSemibold = css`font-family: WorkSansSemibold, sans-serif;`
export const WorkSansBold = css`font-family: WorkSansBold, sans-serif;`
